<template>
  <div
    class="modal has-overflow"
    :class="{ 'is-active': value }">

    <div class="modal-background"
      @click="close()">
    </div>
    
    <div class="modal-content">
      <div class="modal-card">

        <header class="modal-card-head">
          <p class="modal-card-title">Add a Sample</p>
          <button
            class="delete"
            aria-label="close"
            @click="close(true)">
          </button>
        </header>

        <v-form class="modal-card-body" :valid.sync="valid">

          <div class="columns">
            <div class="column">
              <label class="label">Return Date*</label>
              <v-datepicker 
                required
                v-model="request.returned_date"/>
            </div>

            <div class="column">
              <label class="label">Quantity Returned*</label>
              <v-text-field 
                required
                type="number"
                placeholder="Quantity Returned"
                v-model="request.qty_returned"/>
            </div>
          </div>

          <div class="field">
            <label class="label">Returned Condition*</label>
            <v-rich-text 
              v-model="request.returned_condition"/> 
          </div>

        </v-form>

        <footer class="modal-card-foot">
          <button 
            :disabled="!valid"
            class="button is-primary" 
            @click.stop="save()">
            Save
          </button>
          <button 
            class="button" 
            @click.stop="close(true)">
            Cancel
          </button>
        </footer>

      </div>
    </div>

  </div>
</template>

<script>
import VDatepicker from '@/components/base/VDatepicker'
import VTextField from '@/components/base/VTextField'
import VForm from '@/components/base/VForm'
import VRichText from '@/components/base/VRichText'

import { mapState, mapActions } from 'vuex'

export default {
  props: {
    value: {
      type: Boolean
    },
    sampleRequestId: {
      required: true,
      type: [String, Number]
    }
  },
  components: { 
    VDatepicker,
    VTextField, 
    VForm,
    VRichText
  },
  data() {
    return {
      request: {
        returned_date: null,
        qty_returned: null,
        returned_condition: null
      },
      valid: false
    }
  },
  methods: {
    ...mapActions("sampleRequest", ["updateSampleRequest"]),
    save() {
      this.updateSampleRequest({
        sampleRequestId: this.sampleRequestId,
        data: this.request
      }).then(() => {
        this.close();
      });
    },
    close(clear=false) {
      this.$emit('input', false);
      if (clear) {
        this.clearData();
      }
    },
    clearData() {
      Object.assign(this.$data, this.$options.data.call(this));
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/modal.scss';
</style>
